import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { Container, makeStyles } from '@material-ui/core';
import useResponsive from '../../../../utils/responsive';
import useCustomerAddressMethod, {
  ADDRESS_EDIT,
  ADDRESS_GET,
} from '../../hook/useCutomerAddressMethod';
import Layout from '../Layout';
import ComponentCustomerAllAddress from './ComponentCustomerAllAddress';
import { useLanguage } from '../../../../context/language/language';
import useCustomerAddressList from '../../../common/hook/useCustomerAddressList';
import useDeliveryData from '../../../common/hook/useDeliveryData';
import useDeliveryControlFlow from '../../../common/hook/useDeliveryControlFlow';
import {
  CUSTOMER_EDIT_ADDRESS,
  SELECT_STORE
} from '../../../../constant/deliveryFlow';
import { defaultModalSize, mobileContentContainerHeight } from '../modalSize';

const useStyles = makeStyles((theme) => ({
  contentContainer: {
    padding: `0 ${theme.spacing(2)}px`,

    [theme.breakpoints.up('lg')]: {
      padding: 0,
    },
  },
}));

const Main = styled.div(({ theme, width }) => ({
  width,

  '&::-webkit-scrollbar-track': {
    borderRadius: 4,
    backgroundColor: '#FFFFFF',
  },
  '&::-webkit-scrollbar': {
    width: 4,
    backgroundColor: '#FFFFFF',
  },
  '&::-webkit-scrollbar-thumb': {
    borderRadius: 4,
    backgroundColor: '#E8E8E8',
  },
}));

const Title = styled.div(() => ({
  overflow: 'hidden',
  width: '100%',
  display: '-webkit-box',
  WebkitLineClamp: 1,
  WebkitBoxOrient: 'vertical',
  textOverflow: 'ellipsis',
}));

function CustomerViewAllAddress({
  onNext,
  onBack,
  onClose,
  modalRef,
}) {
  const { reset, setDataAddress } = useCustomerAddressMethod();
  const customerAddress = useCustomerAddressList();
  const deliveryData = useDeliveryData();
  const deliveryControl = useDeliveryControlFlow();
  const { isMobile, isTablet, isTabletOrMobile } = useResponsive();
  const word = useLanguage();
  const classes = useStyles();

  const handleAddAddress = () => {
    reset();
    setDataAddress({ customerId: customerAddress.customerId });
    onNext({ data: '', page: CUSTOMER_EDIT_ADDRESS });
  };

  const handleEditAddress = (address) => {
    setDataAddress({
      action: ADDRESS_EDIT,
      customerId: customerAddress.customerId,
      addressId: address.addressId,
      addressDetail: address,
    });
    onNext({ data: address, page: CUSTOMER_EDIT_ADDRESS });
  };

  const handleSelectAddress = (address) => {
    setDataAddress({
      action: ADDRESS_GET,
      customerId: customerAddress.customerId,
      addressId: address.addressId,
      addressDetail: address,
    });
    onNext({ data: address, page: SELECT_STORE });
  };

  React.useEffect(() => {
    if (!customerAddress.addressList) {
      customerAddress.getAddress();
    }
  }, [customerAddress.addressList]);

  const contentContainerRef = useRef(null);
  useEffect(() => {
    mobileContentContainerHeight(contentContainerRef, isMobile, modalRef);
  }, [contentContainerRef]);

  return (
    <>
      <Layout
        title={<Title>{word('DeliveryAddress.SavedAddress')}</Title>}
        onBack={onBack}
        backButtonShown={deliveryControl.stackSize > 1}
        onClose={onClose}
        headerSpace={0.1}
        width={isTablet ? defaultModalSize.tablet.width : defaultModalSize.desktop.width}
        height={isTablet ? defaultModalSize.tablet.height : defaultModalSize.desktop.height}
      >
        <Main>
          <Container className={classes.contentContainer} ref={contentContainerRef}>
            <ComponentCustomerAllAddress
              selectedId={deliveryData.addressId}
              maxLength={5}
              addressList={customerAddress.addressList}
              total={customerAddress.addressList?.length}
              onAdd={handleAddAddress}
              onEdit={handleEditAddress}
              onSelect={handleSelectAddress}
            />
          </Container>
        </Main>
      </Layout>
    </>
  );
}

export default CustomerViewAllAddress;
